import React from 'react';
import styled from 'styled-components';
const Border = () => {
  return <Div />;
};

export default Border;

const Div = styled.div`
  height: 1px;
  width: 100%;
  background: linear-gradient(270deg, #443547 0%, rgba(22, 17, 23, 0) 100%);
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 5;
`;
